import { Component, EventEmitter, Output } from '@angular/core';
import { MorayEastService } from 'src/app/core/services/moray-east.service';
import { MorayEastInstructionsGridDTO } from 'src/app/core/Dtos/moray-east/instructions-grid-dto';
import { AdHocInstructionsGridDTO } from 'src/app/core/Dtos/ad-hoc/instructions-grid-dto';
import { AdHocInstructionsService } from 'src/app/core/services/ad-hoc-instructions.service';
import { Assets } from 'src/app/core/Dtos/assets-enum';
import { DateFormatHelperService } from 'src/app/core/services/date-format-helper.service';
import { UserData } from 'src/app/core/Dtos/user-data.entity';
import { Router } from '@angular/router';
import { BaseComponent } from '../../base-component';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { MorayWestInstructionsGridDTO } from 'src/app/core/Dtos/moray-west/instructions-grid-dto';
import { MorayWestService } from 'src/app/core/services/moray-west.service';
import { FirstHydroInstructionsGridDto } from 'src/app/core/Dtos/fhc-hydro/instructions-grid-dto';
import { FhcHydroService } from 'src/app/core/services/fhc-hydro.service';
import { TraderInstructionArgs } from '../../dashboards-viewer/trader-instruction-view-args';
import { OktaService } from '@engie-group/ngx-gem-spaas';
import { ResService } from 'src/app/core/services/res.service';
import { ResInstructionsGridDTO } from 'src/app/core/Dtos/res/instructions-grid-dto';

@Component({
    selector: 'app-traders-dashboard',
    templateUrl: './traders-dashboard.component.html',
    styleUrl: './traders-dashboard.component.scss',
    standalone: false
})
export class TradersDashboardComponent extends BaseComponent {

    @Output()
    public OnViewInstruction: EventEmitter<TraderInstructionArgs> = new EventEmitter<TraderInstructionArgs>();

    public MorayEastInstructionsData: MorayEastInstructionsGridDTO[] = [];
    public MorayEastAdHocData: AdHocInstructionsGridDTO[] = [];
    public MorayWestInstructionsData: MorayWestInstructionsGridDTO[] = [];
    public MorayWestAdHocData: AdHocInstructionsGridDTO[] = [];
    public FHCInstructionsData: FirstHydroInstructionsGridDto[] = [];
    public FHCAdHocData: AdHocInstructionsGridDTO[] = [];
    public RetailAdHocData: AdHocInstructionsGridDTO[] = [];
    public ResInstructionsData: ResInstructionsGridDTO[] = [];
    public ResAdHocData: AdHocInstructionsGridDTO[] = [];

    public MorayEastLastRefresh: string = "";
    public MorayWestLastRefresh: string = "";
    public FHCLastRefresh: string = "";
    public RetailLastRefresh: string = "";
    public ResLastRefresh: string = "";
    public Assets = Assets; // export enum

    constructor(
        dateFormatHelper: DateFormatHelperService,
        oktaService: OktaService,
        alertService: AlertsService,
        private _morayEastService: MorayEastService,
        private _morayWestService: MorayWestService,
        private _fhcHydroService: FhcHydroService,
        private _adHocService: AdHocInstructionsService,
        private _resService: ResService,
        private _router: Router) {

        super(oktaService, alertService, dateFormatHelper);

        if (this.UserData.IsTrader == false) {
            if (this.UserData.HasMorayEastAccess == true)
                this._router.navigate(["moweo"]);
            else if (this.UserData.HasMorayWestAccess == true)
                this._router.navigate(["mowwl"]);
            else if (this.UserData.HasFHCAccess == true)
                this._router.navigate(["fhc"]);
            else if (this.UserData.HasRetailAccess == true)
                this._router.navigate(["retail"]);
            else if (this.UserData.HasResAccess == true)
                this._router.navigate(["res"]);
        }
        else {
            // Load Instructions
            this.GetMorayEastInstructions();
            this.GetFHCInstructions();
            this.GetRetailInstructions();
            this.GetMorayWestInstructions();
            this.GetResInstructions();
        }
    }

    public GetMorayEastInstructions() {
        this._morayEastService.GetActiveAndFutureInstructions().subscribe(
            resp => {
                this.MorayEastInstructionsData = resp;
                this.MorayEastLastRefresh = this.DateFormatHelper.GetDisplayDate(new Date());
            });
        this._adHocService.GetActiveAndFutureInstructions(Assets.MorayEast).subscribe(
            resp => {
                this.MorayEastAdHocData = resp;
            }
        );
    }

    public GetMorayWestInstructions() {
        this._morayWestService.GetActiveAndFutureInstructions().subscribe(
            resp => {
                this.MorayWestInstructionsData = resp;
                this.MorayWestLastRefresh = this.DateFormatHelper.GetDisplayDate(new Date());
            });
        this._adHocService.GetActiveAndFutureInstructions(Assets.MorayWest).subscribe(
            resp => {
                this.MorayWestAdHocData = resp;
            }
        );
    }

    public GetFHCInstructions() {
        this._fhcHydroService.GetActiveAndFutureInstructions().subscribe(
            resp => {
                this.FHCInstructionsData = resp;
                this.FHCLastRefresh = this.DateFormatHelper.GetDisplayDate(new Date());
            });
        this._adHocService.GetActiveAndFutureInstructions(Assets.FirstHydro).subscribe(
            resp => {
                this.FHCAdHocData = resp;
                this.FHCLastRefresh = this.DateFormatHelper.GetDisplayDate(new Date());
            }
        );
    }

    public GetRetailInstructions() {
        this._adHocService.GetActiveAndFutureInstructions(Assets.Retail).subscribe(
            resp => {
                this.RetailAdHocData = resp;
                this.RetailLastRefresh = this.DateFormatHelper.GetDisplayDate(new Date());
            }
        );
    }

    public GetResInstructions() {
        this._resService.GetActiveAndFutureInstructions().subscribe(
            resp => {
                this.ResInstructionsData = resp;
                this.ResLastRefresh = this.DateFormatHelper.GetDisplayDate(new Date());
            });
        this._adHocService.GetActiveAndFutureInstructions(Assets.Res).subscribe(
            resp => {
                this.ResAdHocData = resp;
                this.ResLastRefresh = this.DateFormatHelper.GetDisplayDate(new Date());
            }
        );
    }


    public OnViewAssetInstruction(asset:Assets, instructionId: string | number, isAdHoc: boolean) {
        this.OnViewInstruction.next(new TraderInstructionArgs(asset, instructionId, isAdHoc));
    }
}
